<template>
    <li class="relative">
        <!-- Tray Link -->
        <button
            @click="($event) => openTray(tray)"
            class="bg-v2-white border border-v2-gray-110 flex gap-3 items-center leading-none max-w-full p-3 rounded text-v2-gray-20 text-left w-full hover:border-v2-gray-70 dark:bg-v2-gray-60 dark:border-v2-gray-10 dark:text-v2-gray-130 hover:dark:border-v2-gray-90 hover:dark:text-v2-white"
        >
            <!-- Icon / Image Slot -->
            <span
                aria-hidden="true"
                class="bg-v2-gray-130 flex items-center justify-center rounded-md shrink-0 size-[60px] dark:bg-v2-gray-50"
            >
                <BaseSvg
                    v-if="tray.name === 'Favorites'"
                    name="HeartOutline"
                    class="fill-tertiary size-6 "
                />
                <span
                    v-else-if="tray.isNew"
                    class="font-medium text-[12px] text-v2-gray-20 uppercase dark:text-v2-gray-90"
                >
              New
            </span>
            <BaseSvg v-else :name="tray.icon ? tray.icon : 'icon-pin-tray'" class="size-6 fill-tertiary" />
          </span>

            <!-- Tray Info -->
            <span class="flex flex-col overflow-hidden mr-16">
                <span class="font-medium">
                    <span class="leading-none mr-1 text-v2-gray-20 dark:text-v2-gray-130">{{ tray.name }}</span>
                    <span class="leading-none text-xs text-v2-gray-90 uppercase">
                        ({{ tray.pin_count }} {{ useHelpers().pluralize(tray.pin_count, 'pin','pins') }})
                    </span>
            </span>
            <span
                v-if="tray.description"
                aria-hidden="true"
                class="text-sm type-tertiary truncate"
            >
                {{ tray.description }}
            </span>
          </span>
        </button>

        <!-- More Button -->
        <div class="absolute right-3 top-3">
            <MoreButton :tray="tray" />
        </div>


        <!-- Confirmation Badge -->
        <span
            :class="['confirmation-ready !top-3/4', { 'confirmation-run': isConfirmRun }]"
            aria-hidden="true"
        >
          <BaseSvg name="Check" aria-hidden="true" class="size-4"/>
          Added
        </span>
    </li>
</template>

<script setup lang="ts">
import {ref, watch, defineProps} from 'vue';
import {BaseSvg, MoreButton} from '@/Components';
import {usePinsDrawer, useHelpers} from '@/Composables';

const props = defineProps(['tray',]);


// Reactive state
const isConfirmRun = ref(false)
const {openTray} = usePinsDrawer();

const emit = defineEmits(['select-tray']);

// Watch confirmation-run trigger
watch(
    () => props.tray,
    () => {
        // For example, run confirmation when new tray created
        isConfirmRun.value = !!props.tray.isNew
        setTimeout(() => (isConfirmRun.value = false), 2000)
    },
    {immediate: true}
)
</script>
